// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__jcxrC","colMaxWidth":"Table_colMaxWidth__26a1Q"};